import { useState } from 'react';
import { useStoreActions } from "../../store/store-context";
import { handleRequest } from "../../infra/utils";
import NotificationActionLayout, { NotificationActionLayoutType } from "../../components/NotificationActionLayout/NotificationActionLayout";
import { Typography, useOverlayContext } from 'seagull';
import { useHistory } from 'react-router-dom';
import { routes } from "../../constants";
import { useIoContext } from "../../contexts";
import { ServerError } from "../../infra/ErrorResponse";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const ApproveTeamMemberInvitation = _ref => {
  let {
    invitingUserName,
    invitingUserEmail,
    invitingBusinessName,
    invitingBusinessId,
    invitationId
  } = _ref;
  const {
    api
  } = useStoreActions();
  const [loading, setLoading] = useState(false);
  const {
    showErrorToast
  } = useOverlayContext();
  const history = useHistory();
  const {
    cookies
  } = useIoContext();
  const {
    setAuthToken
  } = useStoreActions();
  async function sendApproveTeamMemberInvitation() {
    setLoading(true);
    const {
      success,
      error
    } = await handleRequest(api.business.acceptTeamInvite({
      invitationId,
      businessId: invitingBusinessId
    }));
    if (success) {
      // the accept team invite will update the auth token to the new vendor business
      await setAuthToken(cookies.getAuthToken());
      history.push(routes.home);
    } else {
      const errorText = error.hasServerError(ServerError.InvalidTeamInvitation) ? error.invalidTeamInvitationErrorText() : 'Team member invitation approval failed';
      showErrorToast(errorText, 'error-toast');
    }
    setLoading(false);
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "approve-team-member-invitation-page",
    style: {
      height: '100%'
    },
    children: /*#__PURE__*/_jsx(NotificationActionLayout, {
      hideSignInLink: true,
      state: loading ? {
        type: NotificationActionLayoutType.Loading
      } : {
        type: NotificationActionLayoutType.BeforeAction,
        beforeAction: {
          header: /*#__PURE__*/_jsxs(Typography, {
            variant: "h5",
            "data-testid": "notification-before-action-header-text",
            as: "span",
            children: [/*#__PURE__*/_jsxs(Typography, {
              variant: "h5",
              weight: "bold",
              as: "span",
              children: [invitingUserName, ' ']
            }), "(", invitingUserEmail, ") from", ' ', /*#__PURE__*/_jsx(Typography, {
              variant: "h5",
              weight: "bold",
              as: "span",
              children: invitingBusinessName
            }), ' ', "has invited you to join their team on Anchor.", /*#__PURE__*/_jsx("br", {}), "Click the link below to accept the invitation and get started."]
          }),
          buttonText: 'Accept invitation',
          onClick: sendApproveTeamMemberInvitation
        }
      }
    })
  });
};
export default ApproveTeamMemberInvitation;